import { render, staticRenderFns } from "./ClassicSaleIcon.vue?vue&type=template&id=61ad3ef2&"
import script from "./ClassicSaleIcon.vue?vue&type=script&lang=js&"
export * from "./ClassicSaleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports